import { Link } from 'react-router-dom';
import styles from '../../styles/LandingPage.module.css';

export default function LandingNavbar() {
  const scrollToInquiry = (e) => {
    e.preventDefault();
    document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        <span className={styles.navLogo}>MomentBox</span>
        <div className={styles.navActions}>
          <Link to="/client/portal" className={styles.navLink}>
            Client Login
          </Link>
          <a href="#inquiry" className={styles.navCta} onClick={scrollToInquiry}>
            Inquire Now
          </a>
        </div>
      </div>
    </nav>
  );
}
